Namespace('Settings.Views.ChatbotConfiguration')

class Settings.Views.ChatbotConfiguration.IntentsTableView extends Backbone.View
  template: JST['backbone/templates/settings/chatbot_configuration/intents_table']
  className: 'chatbot-configuration-intents-table'

  initialize: (intentsCollection, username) ->
    @intentsCollection = intentsCollection
    @username = username
    @page = 1
    @intentsPerPage = 10
    @fetchedIntents = false

    @descriptionView = new Settings.Views.ChatbotConfiguration.IntentsTableDescriptionPlaceholderView()

    @listenTo(@intentsCollection, 'intents:fetch:success', @displayIntents)
    @listenTo(@intentsCollection, 'intents:save:success', @displaySaveSuccess)

  render: =>
    @$el.html(@template(
      intents: @intentsCollection.models
      normalFlowCount: @intentsCollection.normalFlow().length
      disabledFlowCount: @intentsCollection.disabledFlow().length
      fallbackFlowCount: @intentsCollection.fallbackFlow().length
    ))

    @$el.find('#intents-table-description').html(@descriptionView.render().el)

    @tbody = @$el.find('tbody')
    @renderIntentsList()
    @

  pageChanged: (page) ->
    @page = page
    @renderList()

  renderIntentsList: =>
    @paginateResults(@intentsCollection.models)
    if @fetchedIntents
      @pageChanged(@page)
    else
      @renderPlaceholderList()

  renderList: =>
    @tbody.empty()
    @pageList = @paginatorView.paginator.page(@page)
    _.each @pageList, (intent) =>
      intentRowView = new Settings.Views.ChatbotConfiguration.IntentRowView({model: intent, username: @username})
      @listenTo(intentRowView, 'intent:updated', @notifyIntentUpdate)
      @tbody.append(intentRowView.render().el)

  renderPlaceholderList: =>
    @tbody.empty()
    @appendPlaceholderRowView() for [1..@intentsPerPage]

  paginateResults: (list) ->
    @page = 1
    @paginatorView = new Monitoring.Views.PaginatorView(list, @intentsPerPage)
    @listenTo(@paginatorView, 'paginator:page_changed', @pageChanged)
    @$el.find('.paginator_container').html(@paginatorView.render().el)

  notifyIntentUpdate: =>
    @descriptionView.render()
    @trigger('intent:updated')

  displayPlaceholder: =>
    @fetchedIntents = false
    @descriptionView = new Settings.Views.ChatbotConfiguration.IntentsTableDescriptionPlaceholderView()
    @render()

  appendPlaceholderRowView: =>
    placeholderRowView = new Settings.Views.ChatbotConfiguration.IntentPlaceholderRowView()
    @tbody.append(placeholderRowView.render().el)

  displayIntents: =>
    @fetchedIntents = true
    @descriptionView = new Settings.Views.ChatbotConfiguration.IntentsTableDescriptionView(@intentsCollection)
    @render()

  displaySaveSuccess: ->
    window.showSuccess(I18n.t('navbar.settings.chatbot_configuration.save_ok'))
